const pageCache = {
  state: {
    videoListCache: new Map(),
    videoCurrentSplit: 4
  },
  mutations: {
    SET_VIDEO_CACHE: (state, { orgId, arr }) => {
      state.videoListCache.set(orgId, arr)
    },
    SET_VIDEO_CURRENT_SPLIT: (state, value) => {
      state.videoCurrentSplit = value
    }
  },
  actions: {
    addVideoCache({ commit }, { orgId, arr }) {
      commit('SET_VIDEO_CACHE', { orgId, arr })
    },
    setVideoCurrentSplit({ commit }, value) {
      commit('SET_VIDEO_CURRENT_SPLIT', value)
    }
  }
}

export default pageCache
